import React from "react";
import { assertUndefinedable } from "../../../utils/assertUndefinedable";
import { careMomentsIcons } from "../CareMoments.icons";

export default function CareMomentRankIcon(props: { icon: string; size: number }) {
  const iconKey = props.icon as keyof typeof careMomentsIcons;

  const Icon = assertUndefinedable(careMomentsIcons[iconKey]);

  return Icon === undefined ? null : (
    <Icon style={{ color: "var(--primary-color)", width: props.size, height: props.size }} />
  );
}
